/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ signed: NonNullable<unknown>, issued: NonNullable<unknown> }} Coinvestments_Dataroom_Ndastatus3Inputs */

const en_coinvestments_dataroom_ndastatus3 = /** @type {(inputs: Coinvestments_Dataroom_Ndastatus3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.signed} of ${i?.issued} NDAs signed`)
};

/**
* | output |
* | --- |
* | "{signed} of {issued} NDAs signed" |
*
* @param {Coinvestments_Dataroom_Ndastatus3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_ndastatus3 = /** @type {((inputs: Coinvestments_Dataroom_Ndastatus3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Ndastatus3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_ndastatus3(inputs)
});
export { coinvestments_dataroom_ndastatus3 as "coInvestments_dataRoom_ndaStatus" }